import type { Point } from "@canvas/contracts";

const SVG_WIDTH = 1_000;
const SVG_HEIGHT = 700;
const DEFAULT_PRESSURE = 0.5;

export interface PointerPointInput {
  clientX: number;
  clientY: number;
  pressure: number;
  left: number;
  top: number;
  width: number;
  height: number;
}

function round(value: number, places: number): number {
  const factor = 10 ** places;
  return Math.round(value * factor) / factor;
}

function clamp(value: number, minimum: number, maximum: number): number {
  return Math.min(maximum, Math.max(minimum, value));
}

function translateCoordinate(
  clientPosition: number,
  surfaceOffset: number,
  surfaceSize: number,
  svgSize: number,
): number {
  if (
    !Number.isFinite(clientPosition) ||
    !Number.isFinite(surfaceOffset) ||
    !Number.isFinite(surfaceSize) ||
    surfaceSize <= 0
  ) {
    return 0;
  }

  return clamp(
    round(((clientPosition - surfaceOffset) / surfaceSize) * svgSize, 2),
    0,
    svgSize,
  );
}

function normalizePressure(pressure: number): number {
  const finitePressure = Number.isFinite(pressure) && pressure > 0
    ? pressure
    : DEFAULT_PRESSURE;
  return round(clamp(finitePressure, 0, 1), 3);
}

export function toCanvasPoint(input: PointerPointInput): Point {
  return [
    translateCoordinate(input.clientX, input.left, input.width, SVG_WIDTH),
    translateCoordinate(input.clientY, input.top, input.height, SVG_HEIGHT),
    normalizePressure(input.pressure),
  ];
}
